// Common enum used to map between GQL enum on frontend/server
// and formfn-shared module
enum Currency {
  Ash = "Ash",
  Bonk = "Bonk",
  FamousFoxFederation = "FamousFoxFederation",
  Particles = "Particles",
  SkeletonCrew = "SkeletonCrew",
  Solana = "Solana",
  UsdCoin = "UsdCoin",
}

export default Currency;
